var _clipPath, _path, _g, _path2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 300,
    viewBox: "0 0 120 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v15h70v15H60zm0 30v10h30V0h30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h120v60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c8102e",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l60 30m0-30L0 30",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l60 30m0-30L0 30",
    clipPath: "url(#a)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0v40M0 15h70",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0v40M0 15h70"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0h60v60H0V30h60z",
    fill: "#fedd00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.1039)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1,
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0-513674l301930 929245-790463-574305h977066l-790463 574305",
    fill: "#fedd00",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 -17.5 .29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 17.5 .29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 0 10.29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 0 -9.71)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.cb507a4ad7e4162e584016b1efb9250f.svg";
export { ForwardRef as ReactComponent };